import { render, staticRenderFns } from "./ChangeStatusShareclass.vue?vue&type=template&id=4028bfa5&"
import script from "./ChangeStatusShareclass.vue?vue&type=script&lang=js&"
export * from "./ChangeStatusShareclass.vue?vue&type=script&lang=js&"
import style0 from "./ChangeStatusShareclass.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports